import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import PolicyDetail from './components/PolicyDetails.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManagePolicy',
  components: {
    PolicyDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;